import { handleActions } from "redux-actions";
import initialState from "../../config/initialState";
import {
  GET_INSTRUMENTS_SUCCESS,
  GET_INSTRUMENTS_FAIL,
  EDIT_INSTRUMENT_SUCCESS
} from "../actions/instruments";

export default handleActions(
  {
    [GET_INSTRUMENTS_SUCCESS]: (state, action) => action.payload.instruments,
    [GET_INSTRUMENTS_FAIL]: () => initialState.instruments,
    [EDIT_INSTRUMENT_SUCCESS]: (state, action) => {
      return state.map(instrument => {
        if (instrument.id === action.payload.instrument.id) {
          return action.payload.instrument;
        }

        return instrument;
      });
    }
  },
  initialState.instruments
);
